import React from 'react';

import { stopEventPropagation } from '@lyearn/core/utils/events';
import { useTranslation } from '@lyearn/i18n';
import { CloseFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, Tooltip, Typography } from '@lyearn/ui';

export default function RemoveablePill({
  id,
  name,
  onRemove,
  allowUpdates,
}: {
  id: string;
  name: string;
  onRemove: (id: string) => void;
  allowUpdates: boolean;
}) {
  const { t } = useTranslation();

  const onClick = React.useCallback(
    (event: any) => {
      stopEventPropagation(event);
      onRemove(id);
    },
    [onRemove, id],
  );

  return (
    <Stack
      alignItems="center"
      className={cn('h-32 rounded-24 border border-solid border-border py-4 px-10', {
        'opacity-50': !allowUpdates,
      })}
      gapX={4}>
      <Tooltip enterDelay={500} enterNextDelay={500} title={name}>
        <Typography color="text-text-primary" numberOfLines={1} variant="body-short-02">
          {name}
        </Typography>
      </Tooltip>
      {allowUpdates ? (
        <Tooltip title={t('Common:Actions.Remove')}>
          <Box
            className="flex h-16 w-16 cursor-pointer items-center justify-center text-link-internal hover:text-link-internal-hover"
            onClick={onClick}>
            <CloseFill className="!h-16 !w-16" />
          </Box>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
